import Module, { registerModuleClass } from '@sparta.global.utilities/sparta-module-utility/dist/es6.js';

const Handlebars = require('@sparta.global.vendors/handlebars');
const Template = Handlebars.template({"1":function(container,depth0,helpers,partials,data) {
    var stack1, helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "<div class=\"row\"> <!-- sparta row with overwritten styles -->\n    <div class=\"bgimage column\" style=\"background-image: url('"
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"image") || (depth0 != null ? lookupProperty(depth0,"image") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"image","hash":{},"data":data,"loc":{"start":{"line":9,"column":62},"end":{"line":9,"column":73}}}) : helper)))
    + "');\"> <!-- had to create this nested div because of overwritten styles -->\n        <div class=\"col\"> <!-- sparta column with overwritten styles -->\n            <div class=\"modulecolumn\"> <!-- had to create this nested div because of overwritten styles -->\n                <h3>"
    + ((stack1 = ((helper = (helper = lookupProperty(helpers,"header") || (depth0 != null ? lookupProperty(depth0,"header") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"header","hash":{},"data":data,"loc":{"start":{"line":12,"column":20},"end":{"line":12,"column":32}}}) : helper))) != null ? stack1 : "")
    + "</h3>\n                <p>"
    + ((stack1 = ((helper = (helper = lookupProperty(helpers,"content") || (depth0 != null ? lookupProperty(depth0,"content") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"content","hash":{},"data":data,"loc":{"start":{"line":13,"column":19},"end":{"line":13,"column":32}}}) : helper))) != null ? stack1 : "")
    + "</p>\n            </div>\n        </div>\n    </div>\n</div>\n";
},"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "\n\n"
    + ((stack1 = lookupProperty(helpers,"with").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"data1") : depth0),{"name":"with","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":7,"column":0},"end":{"line":18,"column":9}}})) != null ? stack1 : "")
    + "\n\n\n";
},"useData":true});
const renderTemplate = function (data, options) {
  return Template(data, options);
};

// Import templates & helpers
var _moduleConfig = {
  "name": "@sparta.auto-loans.modules/h3-link-auto-module",
  "version": "1.0.1",
  "id": "h3-link-auto-module",
  "containerID": "autoLoansH3LinkAutoModule",
  "moduleName": "auto-loans-h3-link-auto-module",
  "semantic": true,
  "superModule": false,
  "viewPort": ["small", "medium", "large"],
  "tag": "div",
  "nameSpace": "h3-link-auto-module",
  "data": {
    "init": "AutoLoansH3LinkAutoModule"
  },
  "moduleParams": [],
  "layout": "layout",
  "render": function (context) {
    return renderTemplate(context, {
      "helpers": {},
      "partials": {}
    });
  },
  "template": renderTemplate,
  "partials": {},
  "helpers": {},
  "dependencies": {
    "@sparta.global.utilities/sparta-module-utility": "^1.0.0",
    "@sparta.global.utilities/sparta-style-token-utility": "^1.0.0",
    "@sparta.global.utilities/sparta-style-utility": "^1.0.0"
  },
  "stores": []
};

/**
 * @class H3LinkAutoModule
 * @extends {Module}
 */
class H3LinkAutoModule extends Module {
  /**
   * Creates an instance of H3LinkAutoModule.
   * @param {Object} options Module options
   * @param {Object} context Module context
   */
  constructor(options, context) {
    super({
      ...options,
      context,
      config: _moduleConfig
    });
  }

  /**
   * Totally unecessarily necessary init()
   * @returns {void}
   */
  init() {}
}
registerModuleClass({
  moduleClass: H3LinkAutoModule,
  moduleConfig: _moduleConfig
});
const moduleConfig = _moduleConfig;

export { H3LinkAutoModule as default, moduleConfig };
